import {
    Document,
    PDFViewer,
    Page as PDFPage,
    StyleSheet,
    Text as PDFText,
    View as PDFView,
    Font,
    Image as PDFImage
  } from '@react-pdf/renderer';
  
  Font.register({
    family: 'Roboto',
    fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'medium' }]
  });
  
  const fullScreenStyles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
      backgroundColor: 'white'
    }
  };
  
  const styles = StyleSheet.create({
    page: {
      padding: 10,
      // paddingTop: '5%',
      justifyContent: 'flex-start',
      alignItems: 'center'
    },
    text: {
      fontSize: 10
    },
    textUnderlined: {
      fontSize: 10,
      textDecoration: 'underline',
      textDecorationColor: 'black',
      textDecorationThickness: 1.5,
      width: '120%'
    },
    heading: {
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center'
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '200%',
      gap: 5,
      paddingBottom: '3px',
      borderBottom: '1px solid black',
      paddingTop: '150px',
      paddingRight: '40px',
      paddingLeft: '40px',
      position:"relative",
    },
    contentContainer3: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      borderTop: '1px solid black'
    },
    column: {
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      marginLeft:"7%"
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 2,
      width:"100%"
    },
    label: {
      fontWeight: 'bold',
      fontSize: 10
    },
    value: {
      fontSize: 10,
      fontWeight: 'normal',
      width: '65%'
    }
  });
  
  const Page = ({ style, children, ...props }) => (
    <PDFPage style={{ ...styles.page, ...style }} {...props}>
      {children}
    </PDFPage>
  );
  
  const View = ({ style, children, ...props }) => (
    <PDFView style={{ ...style }} {...props}>
      {children}
    </PDFView>
  );
  
  const Text = ({ style, content, ...props }) => (
    <PDFText style={{ ...styles.text, ...style }} {...props}>
      {content}
    </PDFText>
  );
  
  export const PatientRegistrationPdf20 = ({ data }) => {
    function formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  
    const ageString = data.age;
    const years = ageString.match(/\d+Y/);
  
    return (
      <div style={fullScreenStyles.container}>
        <PDFViewer width="100%" height="100%" showToolbar>
          <Document title={`${data.name} Registration`}>
            <Page size="A4" style={styles.page}>
               <PDFImage src="/PDf Print Format.png" style={{ width: '100%', height: '100%' }} />
            </Page>
            <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="UHID NO.             :-               " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.uhid}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Patient Name     :-             " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.name}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="Consultant          :-          " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={data.consultant}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={styles.row}>
                <Text content="OP Date               :-          " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={`${formatDate(data?.reg_date)} ${data?.reg_time}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View>
                   {/* <View style={styles.row}>
                <Text content="Guardian               :-          " style={{ ...styles.label, fontFamily: 'Roboto' }} />
                <Text
                  content={`${(data?.guardian_name)}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View> */}
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text
                  content="OP No.           :-       "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.op_no}`}
                  style={{
                    ...styles.value,
                    textAlign: 'start',
                    paddingBottom: '2px'
                  }}
                />
              </View>
              <View style={{ ...styles.row, }}>
                <Text
                  content="Age/Sex        :-       "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.age} / ${data.gender}`}
                  style={{ ...styles.value, textAlign: 'start',paddingBottom: '2px' }}
                />
              </View>
              <View style={{ ...styles.row, }}>
                <Text
                  content="Mobile No     :-       "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.mobile}`}
                  style={{ ...styles.value, textAlign: 'start' ,paddingBottom: '2px'}}
                />
              </View>

              <View style={{ ...styles.row,  }}>
                <Text
                  content="Address        :-      "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.address}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View>
                     {/* <View style={{ ...styles.row,  }}>
                <Text
                  content="Net Paid        :-      "
                  style={{ ...styles.label, fontFamily: 'Roboto', position: 'relative', left: '7%' }}
                />
                <Text
                  content={`${data.total}`}
                  style={{ ...styles.value, textAlign: 'start' }}
                />
              </View> */}
            </View>
          </View>
          </Document>
        </PDFViewer>
      </div>
    );
  };
  